const urlPaths = {
  root: () => "/",
  signin: () => "/sign-in",
  // personalDetailsSignup: () => "/old-sign-up",
  signup: () => "/sign-up",
  forgotPassword: () => "/forgot-password",
  // requirements: () => "/onboarding/requirements",
  // onBoardingAdditionalServices: () => "/onboarding/additional-services",
  onBoardingInfo: () => "/onboarding/info-page",
  permission: () => "/onboarding/permission",
  // additionalServices: () => "/additional-services",
  status: () => "/status",
  admin: () => "/admin",
  formRating: () => "/form-rating",
  whatsNext: () => "/form/whats-next",
  index: () => "/index.html",
  kyc: () => "/kyc",
  kycExpress: () => "/express-kyc",
  form: (...subPages: string[]) => ["", "form", ...subPages].join("/"),
  expressForm: (slug: string, subPage: string) => `/express/${slug}/${subPage}`,
  resetPassword: (token?: string) => `/reset-password/${token || ":token"}`,
  statusWithDocumentRequest: (accountId?: string) => `/status/${accountId || ":accountId"}`,
};
// new_account: () => "/status/accounts/new",
// express to non express form,
// etne_account: ()=> "/form/accounts"
// status_query: (account_id: string) => `/status?account_id=${account_id}`,
// status_focus: () => `/status?add_account=true`,

export default urlPaths;
